import { Flex, View, Text } from "@aws-amplify/ui-react";
import ImageIcon from "./ImageIcon";

export default function ImageComponent() {
  return (
    <View
      width="78px"
      height="78px"
      display="block"
      gap="unset"
      alignItems="unset"
      justifyContent="unset"
      overflow="hidden"
      shrink="0"
      position="relative"
      padding="0px 0px 0px 0px"
    >
      <ImageIcon />
    </View>
  );
}
